"use strict";
exports.__esModule = true;
exports.PERMISSIONS = void 0;
exports.PERMISSIONS = [
    'VIEW_ROLE',
    'CREATE_ROLE',
    'EDIT_ROLE',
    'DELETE_ROLE',
    'VIEW_USER',
    'CREATE_USER',
    'EDIT_USER',
    'DELETE_USER',
    'VIEW_PROPERTY',
    'CREATE_PROPERTY',
    'EDIT_PROPERTY',
    'DELETE_PROPERTY',
    'UPLOAD_PROPERTY_IMAGE',
    'VIEW_CONTRACT',
    'CREATE_CONTRACT',
    'EDIT_CONTRACT',
    'DELETE_CONTRACT',
    'VIEW_SPO',
    'CREATE_SPO',
    'EDIT_SPO',
    'DELETE_SPO',
    'VIEW_GEO_INFO',
    'VIEW_CURRENCY',
    'CREATE_CURRENCY',
    'EDIT_CURRENCY',
    'DELETE_CURRENCY',
    'VIEW_EXCHANGE_RATES',
    'CONVERT_EXCHANGE_RATES',
    'CREATE_COMPANY',
    'EDIT_COMPANY',
    'VIEW_COMPANY',
    'DELETE_COMPANY',
    'CREATE_MARKET',
    'EDIT_MARKET',
    'VIEW_MARKET',
    'DELETE_MARKET',
    'CREATE_BANK',
    'EDIT_BANK',
    'VIEW_BANK',
    'DELETE_BANK',
    'CREATE_GLOBAL_DEFINITION',
    'EDIT_GLOBAL_DEFINITION',
    'VIEW_GLOBAL_DEFINITION',
    'DELETE_GLOBAL_DEFINITION',
];
//# sourceMappingURL=permissions.constant.js.map